import Component from "../../lib/component";
import promocodeSvg from "./assets/promocode--1.svg";
import { copyTextToClipboard } from "../../helpers/clipboard";
import TypeWriter from "../../helpers/type_writer";
import Roller from "../../helpers/roller";

export const PromocodeConfig = {
  componentTypeKey: "Promocode",
  baseHtmlClass: "promocode",
  selector: ".promocode",

  datasetConfigKey: "promocode__config",
  codeDatasetConfigKey: "code",
  animateDatasetConfigKey: "animate",
  copyableDatasetConfigKey: "copyable",
  promoTextDatasetConfigKey: "promo_text",

  codeBaseHtmlClass: "promocode__code",
  svgBaseHtmlClass: "promocode__svg",
  rollerMaskBaseHtmlClass: "promocode__roller_mask",
  rollerBaseHtmlClass: "promocode__roller",
  promoTextBaseHtmlClass: "promocode__promo_text",
};

export class Promocode extends Component {
  static get config() {
    return PromocodeConfig;
  }

  constructor(id_or_element) {
    super({
      element: id_or_element,
      config: Promocode.config,
    });

    this.setDatasetConfig(Promocode.config.datasetConfigKey);
    this.code = this.getDatasetConfigValue(Promocode.config.codeDatasetConfigKey);
    this.animate = this.getDatasetConfigValue(Promocode.config.animateDatasetConfigKey);
    this.copyable = this.getDatasetConfigValue(Promocode.config.copyableDatasetConfigKey) !== false;
    this.promoTexts = this.normalizePromoTexts(
      this.getDatasetConfigValue(Promocode.config.promoTextDatasetConfigKey)
    );

    this.element.addEventListener('click', this.handleClick.bind(this));

    this.renderInitial();
    this.render();

    if (this.hasPromoTexts()) {
      this.startPromoTextCycle();
    }
  }

  handleClick(event) {
    if (this.hasCode() && this.copyable) {
      event.preventDefault();
      event.stopPropagation();
      copyTextToClipboard(this.code);
      this.element.classList.add('promocode--copied');
      this.codeElement.innerHTML = "Copied!";
      setTimeout(() => {
        this.element.classList.remove('promocode--copied');
        this.codeElement.innerHTML = this.code;
      }, 2000);
    }
  }

  renderInitial() {
    if (this.hasCode()) {
      this.element.style.display = null;
      const codeContent = this.animate ? "&nbsp;" : this.code;
      const svgHtml = `<div class="${PromocodeConfig.svgBaseHtmlClass}">${this.svg()}</div>`;

      let contentHtml;
      if (this.hasPromoTexts()) {
        // Roller structure: mask > roller > [code, ...promoTexts, code]
        // N+2 items for continuous rolling: code visible, roll through each promo text, roll to code, reset
        // First code can animate, duplicate always shows final code (for seamless reset)
        const promoTextItems = this.promoTexts
          .map(text => `<div class="${PromocodeConfig.promoTextBaseHtmlClass}">${text}</div>`)
          .join("");
        contentHtml = `
          <div class="${PromocodeConfig.rollerMaskBaseHtmlClass}">
            <div class="${PromocodeConfig.rollerBaseHtmlClass}">
              <div class="${PromocodeConfig.codeBaseHtmlClass}">${codeContent}</div>
              ${promoTextItems}
              <div class="${PromocodeConfig.codeBaseHtmlClass}">${this.code}</div>
            </div>
          </div>`;
      } else {
        // No promo_text - just show code directly
        contentHtml = `<div class="${PromocodeConfig.codeBaseHtmlClass}">${codeContent}</div>`;
      }

      this.element.innerHTML = `${svgHtml}${contentHtml}`;

      this.codeElement = this.element.querySelector(`.${PromocodeConfig.codeBaseHtmlClass}`);

      if (this.animate) {
        this.typeWriter = new TypeWriter(this.codeElement, {
          text: this.code,
          delay: 100,
        });
        setTimeout(() => this.typeWriter.start(), 300);
      }
    }
  }

  render() {}

  hasCode() {
    return this.code && this.code.length > 0;
  }

  hasPromoTexts() {
    return this.promoTexts && this.promoTexts.length > 0;
  }

  normalizePromoTexts(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value.filter(t => t && t.length > 0);
    return [value];
  }

  startPromoTextCycle() {
    const rollerElement = this.element.querySelector(`.${PromocodeConfig.rollerBaseHtmlClass}`);

    this.roller = new Roller(rollerElement, {
      initialDelay: 5000,
      displayDuration: 2000,
    });
    this.roller.start();
  }

  svg() {
    return promocodeSvg;
  }

}
